import SkeletonLib, { SkeletonTheme } from 'react-loading-skeleton'
import type { SkeletonProps } from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'

export const Skeleton = (props: SkeletonProps) => {
  return <SkeletonLib {...props} />
}

export { SkeletonTheme }
